const numberSettings = {
  is: {
    delimiter: ',',
    thousand: '.',
  },
  en: {
    delimiter: '.',
    thousand: ',',
  },
  pl: {
    delimiter: ',',
    thousand: ' ',
  },
};

export { numberSettings };
